import { render, staticRenderFns } from "./TwBookingLinking.vue?vue&type=template&id=3fa7a324&scoped=true&"
import script from "./TwBookingLinking.vue?vue&type=script&lang=js&"
export * from "./TwBookingLinking.vue?vue&type=script&lang=js&"
import style0 from "./TwBookingLinking.vue?vue&type=style&index=0&id=3fa7a324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa7a324",
  null
  
)

export default component.exports